import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "react-auth-kit";
import Routers from "./Routes";

import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { PrimeReactProvider } from "primereact/api";

import AnimationThemeProvider from "./helperContext/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./helperContext/Customizer/CustomizerProvider";
import { useMaterialUIController } from "./helperContext/context";

import { ThemeProvider } from "@mui/material/styles";

import "@mantine/core/styles.css";
import "mantine-react-table/styles.css";

// import theme from "assets/theme";
import theme from "./assets/theme";
import themeDark from "./assets/theme-dark";

import "@mantine/core/styles/Input.css";

// import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
//import "primereact/resources/themes/saga-orange/theme.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "leaflet/dist/leaflet.css";
import "./customform.css";
import i18n from "i18n";

import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const App = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  document.documentElement.style.setProperty("--theme-default", "#2653a5");

  const value = {
    appendTo: "self",
  };

  useEffect(() => {
    // Remove hardcoded language change
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <PrimeReactProvider value={value}>
          <ThemeProvider theme={darkMode ? themeDark : theme}>
            <CustomizerProvider>
              <AnimationThemeProvider>
                <Provider store={store}>
                  <AuthProvider
                    authType={"cookie"}
                    authName={"_auth"}
                    cookieDomain={window.location.hostname}
                    cookieSecure={window.location.protocol === "https:"}
                  >
                    <Routers />
                  </AuthProvider>
                </Provider>
              </AnimationThemeProvider>
            </CustomizerProvider>
          </ThemeProvider>
        </PrimeReactProvider>
      </div>
    </QueryClientProvider>
  );
};

export default App;
